document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mobile-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      const open = menu.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-filter-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const filters = document.querySelector('[data-filters]');
      if (!filters) return;
      filters.classList.toggle('is-open');
    });
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-qty]').forEach((wrapper) => {
    const input = wrapper.querySelector('input');
    wrapper.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const delta = button.dataset.action === 'plus' ? 1 : -1;
        const next = Math.max(1, Number(input.value || 1) + delta);
        input.value = next;
      });
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    let product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    const form = root.querySelector('form[action*="/cart/add"]');
    const idInput = form ? form.querySelector('input[name="id"]') : null;
    const addButton = form ? form.querySelector('[data-add-button]') : null;
    const priceEl = root.querySelector('[data-current-price]');
    const compareEl = root.querySelector('[data-compare-price]');
    const saveEl = root.querySelector('[data-save-badge]');
    const currency = root.dataset.currency || 'GBP';

    const formatMoney = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency, maximumFractionDigits: cents % 100 === 0 ? 0 : 2
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + currency;
      }
    };

    const updateVariant = () => {
      const selected = Array.from(root.querySelectorAll('[data-option-group]')).map((group) => {
        const checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      const variant = product.variants.find((v) => v.options.every((value, index) => value === selected[index]));
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (saveEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          saveEl.textContent = `SAVE ${pct}%`;
          saveEl.hidden = false;
        } else { saveEl.hidden = true; }
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? addButton.dataset.availableText : addButton.dataset.soldText;
      }
      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    };

    root.querySelectorAll('[data-option-group] input').forEach((input) => input.addEventListener('change', updateVariant));
  });
});
